import type { Dayjs } from "dayjs";
import { dayjs } from "@bigbinary/neeto-commons-frontend/utils";

/**
 * Apply the configured timezone to a date value.
 * Strips the original timezone and reinterprets via neetocommons' dayjs wrapper.
 * Handles both single dates and arrays (for date ranges).
 */
export const getTimezoneAppliedDateTime = (
  inputDateTime: Dayjs | Dayjs[] | null
): Dayjs | (Dayjs | null)[] | null => {
  const apply = (date: Dayjs | null): Dayjs | null =>
    date && typeof date.format === "function"
      ? dayjs(date.format("YYYY-MM-DD HH:mm:ss"))
      : null;

  return Array.isArray(inputDateTime)
    ? inputDateTime.map(apply)
    : apply(inputDateTime);
};
